const endSelection = (suggestedValue, setEnteredValue, setOff, setIsNavigated, onSelection) => {
    setEnteredValue(suggestedValue);
    onSelection && onSelection(suggestedValue);
    setOff();
    setIsNavigated(false);
};
export default endSelection;
//# sourceMappingURL=endSelection.js.map